import { cn } from '../../utils/cn'

/** Inline validation message shown under a form field. Renders nothing when empty. */
export function FieldError({ message, onDark = false }: { message?: string; onDark?: boolean }) {
  return message ? (
    <p className={cn('text-xs', onDark ? 'text-(--red-text-on-dark)' : 'text-destructive')}>{message}</p>
  ) : null
}
